import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { castingInitialState } from './constants';

const castingSlice = createSlice({
  name: 'casting',
  initialState: castingInitialState,
  reducers: {
    saveCastingSessionId: (state, action: PayloadAction<string>) => {
      state.castingSessionId = action.payload;
    },
  },
});

export const { saveCastingSessionId } = castingSlice.actions;

export default castingSlice.reducer;
